<div id="item-list-container" class=" mt-6 w-full md:px-[3.5rem]">

    <div class="flex flex-col w-full items-start gap-4 container mx-auto">

        <h3 class="font-noto-serif text-[var(--dark-teal)] text-3xl font-bold">Auctions</h3>


        <div class="w-full overflow-x-auto md:overflow-visible mt-10">
            <div class="flex  gap-3">

                <button *ngFor="let btn of buttons" (click)="onButtonCategoryFilterClick(btn.id)" [ngClass]="{
                    'bg-[#015789] hover:bg-[#014a79]':
                    selectedCategory() === btn.id,
                    'bg-[#007BC2] hover:bg-[#006aaa] ':
                    selectedCategory() !== btn.id
                }" class="min-w-[159px] h-[35px] border rounded-md flex items-center justify-center font-noto-serif text-white">
                    {{ btn.label }}
                </button>

            </div>

        </div>

        <div class="flex flex-col md:flex-row  w-full gap-2 md:mr-auto mt-7 px-4 lg:px-0">


            <p-multiselect *ngIf="!isMobile" [options]="causes()" [(ngModel)]="selectedCauses" placeholder="Causes"
                display="chip" class="text-xs h-[35px] md:w-[200px] w-full" />

            <p-select [options]="sortFilters" [(ngModel)]="selectedSortSignal" placeholder="Sort by"
                class="text-xs w-full h-[35px]  md:w-[150px]  ">
            </p-select>

            <button *ngIf="isMobile"
                class="w-full h-[35px] bg-white border rounded-md text-left px-3 text-gray-600 flex justify-between items-center border-gray-300"
                (click)="openBottomSheet()">
                <span class="text-gray-600 text-xs truncate block max-w-[80%]"> {{causesLabel}} </span>
                <i class="pi pi-chevron-down text-gray-600"></i>
            </button>

            <ng-container *ngIf="bottomSheetCausesVisible"> <ng-template
                    *ngTemplateOutlet="bottomSheetCauses"></ng-template> </ng-container>


            <!-- country bottom sheet -->

            <p-select *ngIf="!isMobile" [options]="filteredCountries()" [(ngModel)]="selectedCountries"
                placeholder="Country" display="chip" (onChange)="onCountryChange($event.value)"
                class="text-xs w-full h-[35px]  md:w-[150px]  " optionLabel="name" optionValue="abbreviation" />

            <button *ngIf="isMobile"
                class="w-full h-[35px] bg-white border rounded-md text-left px-3 text-gray-600 flex justify-between items-center border-gray-300"
                (click)="openBottomSheetCountry()">
                <span class="text-gray-600 text-xs">{{selectedCountryName() ? selectedCountryName() : 'Country'}}</span>
                <i class="pi pi-chevron-down text-gray-600"></i>
            </button>

            <ng-container *ngIf="bottomSheetCountryVisible"> <ng-template
                    *ngTemplateOutlet="bottomSheetCountry"></ng-template> </ng-container>



            <!-- state bottom sheet -->
            <p-select *ngIf="!isMobile" [options]="states()" [(ngModel)]="selectedState" placeholder="State/Province"
                display="chip" class="text-xs w-full h-[35px] md:w-[150px] " optionLabel="name"
                optionValue="abbreviation" (onChange)="onStateChange($event.value)" />

            <button *ngIf="isMobile"
                class="w-full h-[35px] bg-white border rounded-md text-left px-3 text-gray-600 flex justify-between items-center border-gray-300"
                (click)="openBottomSheetState()">
                <span class="text-gray-600 text-xs"> {{ selectedStateName() || 'State/Province'}} </span>
                <i class="pi pi-chevron-down text-gray-600"></i>
            </button>


            <ng-container *ngIf="bottomSheetStateVisible"> <ng-template
                    *ngTemplateOutlet="bottomSheetState"></ng-template> </ng-container>


            <button pButton pRipple icon="pi pi-trash" class="p-button-outlined text-sm sm:w-1/4 lg:w-auto"
                [style]="{ 'height': '35px', 'max-width': '100px' }" (click)="clearFilters()"></button>


            <div class=" hidden md:block md:ml-auto">
                <p-selectbutton [options]="this.ItemListOptions" [(ngModel)]="viewMode" optionLabel="label"
                    optionValue="value" allowEmpty="false"
                    class="custom-p-selectbutton h-[37px] border-none  md:ml-auto">
                    <ng-template #item let-item class="">
                        <p-button [text]="item.value!=viewMode" class="custom-p-button">
                            <fa-icon class="text-[12px]"
                                [icon]="item.value == 'image' ? icons.faImage : icons.faList"></fa-icon>
                            <span class="whitespace-nowrap text-[12px]">{{item.label}}</span>
                        </p-button>
                    </ng-template>
                </p-selectbutton>
            </div>
        </div>
    </div>

</div>

<div class="mb-20">
    @if(viewMode === 'image')
    {
    <app-auction-listing-vertical-view [auctions]="sortedItems()"
        (myAuctionChanged)="onMyAuctionsChanged($event)"></app-auction-listing-vertical-view>
    }@else
    {
    <app-auction-listing-horizontal-view [auctions]=" sortedItems()"
        (myAuctionChanged)="onMyAuctionsChanged($event)"></app-auction-listing-horizontal-view>
    }

</div>



<!-- <p-paginator [rows]="rows()" [first]="first()" [totalRecords]="auctions()?.length"
    [rowsPerPageOptions]="rowsPerPageOptions" (onPageChange)="onPageChange($event)" styleClass="mt-7 text-sm">
</p-paginator> -->

<ng-template #bottomSheetCauses>

    <div *ngIf="bottomSheetCausesVisible" class="fixed inset-0 bg-black/40 z-40" (click)="closeBottomSheet()">
    </div>

    <div *ngIf="bottomSheetCausesVisible" class="fixed left-0 right-0 bottom-0 z-50 
         bg-white rounded-t-2xl shadow-xl
         animate-slide-up max-h-[60vh] overflow-y-auto px-4 mx-3">

        <div class="flex justify-center py-3">
            <div class="w-12 h-1.5 bg-gray-300 rounded-full"></div>
        </div>

        <div class="px-4 pb-8">
            <h3 class="font-semibold text-lg mb-4">Select Causes</h3>

            <div *ngFor="let c of causes()" class="flex items-center py-2">
                <input type="checkbox" [checked]="selectedCauses().includes(c)" (change)="toggleCause(c)"
                    class="mr-3 h-3 w-3 cursor-pointer" />
                <span class="text-[var(--panorama-gray)]">{{ c }}</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #bottomSheetCountry>

    <div *ngIf="bottomSheetCountryVisible" class="fixed inset-0 bg-black/40 z-40" (click)="closeBottomSheetCountry()">
    </div>

    <!-- BOTTOM SHEET -->
    <div *ngIf="bottomSheetCountryVisible" class="fixed left-0 right-0 bottom-0 z-50 
         bg-white rounded-t-2xl shadow-xl
         animate-slide-up max-h-[60vh] overflow-y-auto mx-3">

        <div class="flex justify-center py-3">
            <div class="w-12 h-1.5 bg-gray-300 rounded-full"></div>
        </div>

        <div class="px-4 pb-8">
            <h3 class="font-semibold text-lg mb-4">Select Country</h3>

            <div *ngFor="let c of country()" class="flex items-center py-2">
                <input type="radio" name="countryOptions" [value]="c.abbreviation " [(ngModel)]="selectedCountries"
                    (change)="onCountryChange(c.abbreviation)" class="mr-3 h-3 w-3 cursor-pointer" />
                <span class="text-[var(--panorama-gray)]">{{ c.name }}</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #bottomSheetState>

    <div *ngIf="bottomSheetStateVisible" class="fixed inset-0 bg-black/40 z-40" (click)="closeBottomSheetState()">
    </div>

    <!-- BOTTOM SHEET -->
    <div *ngIf="bottomSheetStateVisible" class="fixed left-0 right-0 bottom-0 z-50 
         bg-white rounded-t-2xl shadow-xl
         animate-slide-up max-h-[60vh] overflow-y-auto mx-3">

        <div class="flex justify-center py-3">
            <div class="w-12 h-1.5 bg-gray-300 rounded-full"></div>
        </div>

        <div class="px-4 pb-8">
            <h3 class="font-semibold text-lg mb-4"> Select State</h3>

            <div *ngFor="let s of states()" class="flex items-center py-2">
                <input type="radio" name="countryOptions" [value]="s.abbreviation " [(ngModel)]="selectedState"
                    (change)="onStateChange(s.abbreviation)" class="mr-3 h-3 w-3 cursor-pointer" />
                <span class="text-[var(--panorama-gray)]">{{ s.name }}</span>
            </div>
        </div>
    </div>
</ng-template>